<template>
    <div>
        <b-modal
                v-model="show"
                no-close-on-backdrop
                @close="close(false)"
                size="md"
                title="Активация бонусной услуги"
        >
            <v-container align-center>
                <v-row no-gutters class="mb-4">
                    <v-col cols="8" v-if="stepNumber==1">
                        <span class="custom-group-label">Укажите код для активации услуги и просмотра данных клиента</span>
                    </v-col>
                    <v-col cols="8" v-else>
                        <span class="custom-group-label">Подтвердите данные для обработки бонуса.</span>
                    </v-col>
                    <v-col cols="4" class="text-right">
                        <span class="step-info">Шаг {{stepNumber}}/2</span>
                    </v-col>
                </v-row>
                <template v-if="stepNumber==1">
                   <v-row no-gutters>
                       <v-col>
                           <label class="custom-input-label">Код активации</label>
                           <b-input
                                   id="code-input"
                                   placeholder="______"

                                   :formatter="formatCode"
                                   v-model="bonusCode"

                           />
                       </v-col>
                   </v-row>
                </template>
                <template v-else>
                    <v-row no-gutters class="mb-1 pr-2">
                        <v-col cols="8">
                            <label class="custom-input-label">Бонусная услуга</label>
                            <div class="disabled-filled-option">{{clientInfo.bonusName}}</div>
                        </v-col>
                        <v-col cols="4" class="pl-2">
                            <label class="custom-input-label">Доступно клиенту</label>
                            <div class="disabled-filled-option">{{clientInfo.allowCount}}</div>
                        </v-col>
                    </v-row>
                    <b-row no-gutters class="mb-1">
                        <b-col>
                            <label class="custom-input-label">ФИО</label>
                            <div class="disabled-filled-option">{{clientInfo.clientFio}}</div>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class="mb-1">
                        <b-col>
                            <label class="custom-input-label">Транспортное средство</label>
                            <div class="disabled-filled-option">{{clientInfo.clientCar}}</div>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class="mb-1">
                        <b-col cols="4">
                            <label class="custom-input-label">Бонусный пакет</label>
                            <div class="disabled-filled-option">{{clientInfo.bonusPacket}}</div>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class="mb-1">
                        <b-col cols="4">
                            <label class="custom-input-label">Регистрация</label>
                            <div class="disabled-filled-option">{{formatDate(clientInfo.registrationDate)}}</div>
                        </b-col>
                    </b-row>
                    <b-row no-gutters class="mb-1">
                        <b-col cols="4">
                            <label class="custom-input-label">Статус</label>
                            <div class="disabled-filled-option" style="color:#27AE60">{{clientInfo.clientStatusName}}</div>
                        </b-col>
                    </b-row>
                </template>


            </v-container>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">

                        <v-spacer></v-spacer>
                        <v-col v-if="stepNumber==1" cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    :dark="bonusCode.length==6"
                                    size="sm"
                                    @click="checkBonusCode"
                                    :disabled="bonusCode.length!=6"
                            >
                                Далее
                            </v-btn>
                        </v-col>
                        <v-col v-else cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="registerActivation"
                            >
                                Подтвердить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="close(false)"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>

    </div>
</template>

<script>
    export default {
        name: "AddBonusModal",
        props:{
            show:Boolean,

        },
        data(){
            return {
                stepNumber:1,
                clientInfo:{
                    id: null,
                    allowCount: null,
                    bonusName: null,
                    bonusPacket: null,
                    bonusPacketCode: null,
                    clientCar: null,
                    clientFio: null,
                    clientStatusCode: null,
                    clientStatusId: null,
                    clientStatusName:null,
                    registrationDate: null
                },

                bonusCode:"",


            }
        },

        computed:{

        },
        methods:{
            //получить информацию о клиенте по коду активации

            //отправить бонус в работу
            checkBonusCode(){
                const vm=this
                this.$store.dispatch("ActivationBonus/getClientByCode", this.bonusCode).then((data)=>{
                    for(let key in this.clientInfo){
                        if(data.hasOwnProperty(key))
                            this.clientInfo[key]=data[key]
                    }
                    vm.stepNumber=2
                }).catch(error=>{
                    this.$bvToast.toast(error.message, {
                        title: `Ошибка проверки кода!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            registerActivation(){
                this.$store.dispatch("ActivationBonus/setBonusInProgress", this.clientInfo.id).then(()=>{
                    this.close(true)
                    this.$bvToast.toast("Бонус отправлен в работу", {
                        variant: "success",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                })
            },

            changeCode(value){
                console.log(value)
                let input = document.getElementById("code-input")
                value=value.substring(0,6)
                value=value.replace(/\D/, "")
                value=value.padEnd(6,"_")
                let numberString = value.substring(value.indexOf("_"),"");
                input.setSelectionRange(numberString.length,numberString.length)
            },

            formatCode(value){
                value=value.substring(0,6)
                value=value.replace(/\D/, "")
                //value=value.padEnd(6,"_")
                return value
            },



            close(isSave){
                this.$emit("close", isSave)
            }
        },
        watch:{
            show(value){
                if(value==true){
                    this.stepNumber=1
                    this.bonusCode=""

                }
            }
        }

    }
</script>

<style scoped>
    #code-input{
        font-weight: 500;
        font-size: 32px;
        line-height: 39px;
        letter-spacing: 3px;
    }
    #code-input::placeholder {
        font-weight: 500;
        font-size: 32px;
        line-height: 39px;
        letter-spacing: 3px;
    }
</style>